/**
 * Context + hook for the Lean & Clean onboarding tour (Phase 5B).
 *
 * Split out of `LeanCleanTourProvider.tsx` because React Refresh
 * requires component files to export only components — keeping the
 * context object and the hook here lets the provider file stay pure
 * React and preserves HMR behaviour.
 */

import { createContext, useContext } from 'react';

export interface TourContextValue {
  /** Imperatively start the tour for the current context. */
  start: () => void;
  /** Close the tour if it is currently running. */
  stop: () => void;
  /**
   * Restart from the first step, ignoring the completed-version
   * marker. Used by the Settings "Tour erneut starten"-button.
   */
  restart: () => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

export function useLeanCleanTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error(
      'useLeanCleanTour() must be called inside <LeanCleanTourProvider>.',
    );
  }
  return ctx;
}
